import React, { useEffect, useState } from "react";
import parrow from "./parrow.png";
import narrow from "./narrow.png";
import ScrollReveal from "./ScrollReveal";

export const Team = ({ team }) => {
  const [result, setResult] = useState(team);
  const [start, setStart] = useState(0);
  const [end, setEnd] = useState(4);
  const [page, setPage] = useState(1);

  const totalPages = Math.ceil(team.length / 4);

  useEffect(() => {
    setResult(team.slice(start, end));
  }, [start, team]);

  useEffect(() => {
    // Debug: Log all team image URLs on initial render
    if (team && team.length > 0) {
      // console.log("🔗 Team Image URLs from S3:");
      team.forEach((member, index) => {
        // console.log(`${index + 1}. ${member.title}: ${member.image}`);
      });
    }
  }, [team]);

  const Next = () => {
    setPage((prev) => prev + 1);
    setStart((prev) => prev + 4);
    setEnd((prev) => prev + 4);
  };

  const Previous = () => {
    setPage((prev) => prev - 1);
    setStart((prev) => prev - 4);
    setEnd((prev) => prev - 4);
  };

  return (
    <div id="team" className="text-center">
      <div className="container-fluid">
        <div className="row">
          <div className="col-8 section-title">
            <h2>Meet the Team</h2>
          </div>
        </div>
        <div className="row">
          <div className="col-12 d-flex justify-content-center align-items-center flex-wrap">
            {result && result.length > 0 ? (
              result.map((item, i) => (
                <div
                  key={`${item.title}-${i}`}
                  className="col-md-3 col-sm-6 team"
                >
                  <div className="thumbnail">
                    <img
                      src={item.image}
                      alt={item.title}
                      onError={(e) => {
                        e.target.src = "/default-user.png";
                      }}
                      style={{
                        borderRadius: "40px",
                        height: "250px",
                        width: "250px",
                        objectFit: "cover",
                      }}
                    />
                    <div className="caption">
                      <h4>{item.title}</h4>
                      <p>{item.description}</p>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <p>Loading...</p>
            )}
          </div>
        </div>
        {totalPages > 1 && (
          <div className="col-4 d-flex justify-content-end align-items-center">
            <button
              disabled={page === 1}
              onClick={Previous}
              style={{
                fontSize: "60px",
                border: "none",
                background: "transparent",
                cursor: "pointer",
                marginRight: "20px",
              }}
            >
              <img src={parrow} alt="Previous" />
            </button>
            <button
              disabled={page + 1 > totalPages}
              onClick={Next}
              style={{
                fontSize: "60px",
                border: "none",
                background: "transparent",
                cursor: "pointer",
              }}
            >
              <img src={narrow} alt="Next" />
            </button>
          </div>
        )}

      </div>
    </div>
  );
};

